<template>
  <div class="select-budget">
    <div class="options">
      <div
        class="option"
        v-for="o in options"
        v-bind:key="o.value"
        @click="model = o.value"
      >
        <Select
          :icon="o.icon"
          :title="o.title"
          :checked="selected.includes(o)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Select from './Select.vue'
export default {
  props: {
    input: null
  },
  data() {
    return {
      selected: []
    }
  },
  components: {
    Select
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        const item = this.options.find(o => o.value === v)

        const selectedIndex = this.selected.findIndex(s => s.value === v)
        if (selectedIndex >= 0) {
          this.selected.splice(selectedIndex, 1)
        } else {
          this.selected.push(item)
        }

        // check if other items have to be added
        // e.g. if the user selects both options 0-20 and 50-100, the option 20-50 should be automatically selected
        const [min, max] = this.selected.reduce(
          (acc, current) => {
            const low = this.getRange(current.value)[0]
            const high = this.getRange(current.value)[1]
            if (!acc[0] && acc[0] !== 0) {
              acc[0] = low
            }
            if (!acc[1]) {
              acc[1] = high
            }
            if (low <= acc[0]) {
              acc[0] = low
            }
            if (high >= acc[1]) {
              acc[1] = high
            }
            return acc
          },
          [null, null]
        )

        this.options.forEach(option => {
          const [low, high] = this.getRange(option.value)
          if (this.selected.includes(option) || (low === min && high === max)) {
            return
          }
          if (low >= min && high <= max) {
            this.selected.push(option)
          }
        })
        this.$emit('input', min + '-' + max)
      }
    },
    options() {
      return this.input.options || []
    }
  },
  methods: {
    getRange(value) {
      if (value === this.$root.__('budget doesnt matter')) {
        return [0, 105]
      }
      if (value === '+100') {
        return [100, 105]
      }
      return value.split('-').map(Number)
    }
  }
}
</script>

<style>
.options {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0.5em;
}
.option {
  position: relative;
  padding: 8px 8px 8px 1em;
  flex-grow: 1;
  width: 50%;
  max-width: 140px;
  height: 100px;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 1px 2px rgba(0, 0, 0, 0.04),
    0px 1px 2px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  margin: 0 1em 1em 0;
  color: black;
}
.option:hover {
  cursor: pointer;
}
.option-title {
  position: absolute;
  left: 1em;
  bottom: 1em;
  color: #696e80;
}
.option-check {
  float: right;
}
.option-checked {
  fill: #2dc76d;
}
.option-unchecked {
  fill: rgba(0, 0, 0, 0.2);
}
.option-icon {
  display: inline-block;
}
</style>